module.exports = __webpack_public_path__ + "static/media/7_Отчет_ДВИ_20160622.3fcf893d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/7_Отчет_ДВИ_20160622.pdf
// module id = 170
// module chunks = 0